import React, { ReactElement } from 'react';

import LeashLayout from 'leash/components/layout/LeashLayout';
import { DetailsContent } from 'leash/pages/details/detailsContent/DetailsContent';
import { DetailsProvider } from './useDetailsState';

export function Details(): ReactElement {
  return (
    <LeashLayout>
      <DetailsProvider>
        <DetailsContent />
      </DetailsProvider>
    </LeashLayout>
  );
}
